var hybrid =
  hybrid ||
  (function () {
    var nativeInjectName = "moliao";
    var ua = navigator.userAgent;
    var isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Adr") > -1;
    var isIOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    var nextCallbackId = 1;
    var nativeCallbackMap = {};
    function callAndroid(nativeMethodName, params, callback) {
      var wrapper = {};
      if (params) {
        wrapper.params = params;
      }
      if (callback) {
        wrapper.callbackId = nextCallbackId;
        nativeCallbackMap[nextCallbackId] = callback;
        nextCallbackId++;
      }
      try {
        window[nativeInjectName][nativeMethodName](JSON.stringify(wrapper));
      } catch (e) {
        console.log("callAndroid error: " + e);
        delete nativeCallbackMap[wrapper.callbackId];
      }
    }
    function callIOS(nativeMethodName, params, callback) {
      var wrapper = {
        method: nativeMethodName,
      };
      if (params) {
        wrapper.params = params;
      }
      if (callback) {
        wrapper.callbackId = nextCallbackId;
        nativeCallbackMap[nextCallbackId] = callback;
        nextCallbackId++;
      }
      try {
        window.webkit.messageHandlers[nativeInjectName].postMessage(JSON.stringify(wrapper));
      } catch (e) {
        console.log("callIOS error: " + e);
        delete nativeCallbackMap[wrapper.callbackId];
      }
    }
    var obj = {};
    obj.isValid = (function () {
      if (isAndroid) {
        return window[nativeInjectName] != null;
      } else if (isIOS) {
        return (
          window.webkit != null &&
          window.webkit.messageHandlers != null &&
          window.webkit.messageHandlers[nativeInjectName] != null
        );
      } else {
        return false;
      }
    })();
    obj.callNative = function (nativeMethodName, params, callback) {
      if (isAndroid) {
        callAndroid(nativeMethodName, params, callback);
      } else if (isIOS) {
        callIOS(nativeMethodName, params, callback);
      } else {
        console.log("Unknown client");
      }
    };
    obj.__onCallNativeCallback = function (wrapperString) {
      var wrapper = JSON.parse(wrapperString);
      var callback = nativeCallbackMap[wrapper.callbackId];
      if (callback) {
        delete nativeCallbackMap[wrapper.callbackId];
        callback(wrapper.params);
      }
    };
    obj.__onCallNativeError = function (wrapperString) {
      var wrapper = JSON.parse(wrapperString);
      console.log("onCallNativeError: " + wrapper.message);
      delete nativeCallbackMap[wrapper.callbackId];
    };
    var jsCallMap = {};
    obj.registerNativeCall = function (name, func) {
      jsCallMap[name] = func;
    };
    obj.__onNativeCall = function (wrapperString) {
      var wrapper = JSON.parse(wrapperString);
      var func = jsCallMap[wrapper.name];
      if (func) {
        return func(wrapper.params);
      }
    };
    return obj;
  })();

window.hybrid = hybrid;

export default {
  isValid: hybrid.isValid,
  callNative: hybrid.callNative,
  registerNativeCall: hybrid.registerNativeCall,
};
